import { toInteger } from 'lodash';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useClient, usePinTalkingPoint, useUnPinTalkingPoint } from '../api';
import { showWarningToast } from '../utils/toastUtils';
import { useIsTalkingPointPinned } from './useIsTalkingPointPinned';

export const useHandleTalkingPointPin = (
    talkingPointId?: number,
): [isTalkingPointPinned: boolean, handleOnCheckboxClick: (event: CustomEvent<boolean>) => void] => {
    const isPinned = useIsTalkingPointPinned(talkingPointId);
    const [isTalkingPointPinned, setIsTalkingPointPinned] = useState(isPinned);
    const params = useParams();
    const topicId = toInteger(params.topicId);
    const { t } = useTranslation();

    const { data: client } = useClient();
    const pinTalkingPoint = usePinTalkingPoint();
    const unPinTalkingPoint = useUnPinTalkingPoint();

    const handleOnCheckboxClick = useCallback(
        (event: CustomEvent<boolean>) => {
            const prevState = isTalkingPointPinned;
            setIsTalkingPointPinned(event.detail);
            if (event.detail) {
                pinTalkingPoint.mutate(
                    { clientId: client!.id, talkingPointId: talkingPointId!, topicId },
                    {
                        onError: () => {
                            setIsTalkingPointPinned(prevState);
                            showWarningToast({ userMessage: t('failureNoActiveClient') });
                        },
                    },
                );
            } else {
                unPinTalkingPoint.mutate(
                    { talkingPointId: talkingPointId!, topicId },
                    {
                        onError: () => {
                            setIsTalkingPointPinned(prevState);
                            showWarningToast({ userMessage: t('failureNoActiveClient') });
                        },
                    },
                );
            }
        },
        [isTalkingPointPinned, setIsTalkingPointPinned, pinTalkingPoint, unPinTalkingPoint, t, talkingPointId, topicId, client],
    );

    return [isTalkingPointPinned, handleOnCheckboxClick];
};
